<template>
  <section class="py-8 px-4 xl:px-0 mx-auto max-w-screen-lg">
    <form @submit.prevent="handleSubmit" class="flex flex-col gap-3 min-w-full">
      <div>
        <label for="name-input">Vor- & Nachname</label> <br />
        <input
          v-model="name"
          type="text"
          placeholder="Vor- & Nachname"
          class="input"
          id="name-input"
          required
        />
      </div>

      <div>
        <label for="email-input">Email Adresse</label> <br />
        <input
          v-model="email"
          type="email"
          placeholder="Email Adresse"
          class="input"
          id="email-input"
          required
        />
      </div>

      <div>
        <label for="regular-visitors-input"
          >Reguläre Karten (ab 18 Jahre)</label
        >
        <br />
        <input
          v-model="regularCards"
          type="number"
          min="0"
          max="15"
          id="regular-visitors-input"
          placeholder="Anzahl der Karten"
          class="input"
          required
        />
      </div>

      <div>
        <label for="discount-visitors-input"
          >Ermäßigte Karten (3-17 Jahre)</label
        >
        <br />
        <input
          v-model="discountCards"
          type="number"
          min="0"
          max="15"
          id="discount-visitors-input"
          placeholder="Anzahl der Karten"
          class="input"
          required
        />
      </div>

      <div>
        <label for="performance-select">Vorstellung wählen</label> <br />

        <select
          v-model="performance"
          name="performance-select"
          id="performance-select presale-form"
          class="input"
          required
        >
          <option disabled selected>Vorstellung wählen</option>
          <hr />
          <PerformanceOptionGroup
            :performances="performances"
            :special-performance="true"
          />
          <PerformanceOptionGroup
            :performances="performances"
            :special-performance="false"
          />
          <hr />
        </select>
      </div>

      <div class="flex flex-row items-center gap-2">
        <input type="checkbox" id="terms-checkbox" required />
        <label for="terms-checkbox" class="select-none"
          >Ich habe die
          <NuxtLink to="/legal/presale-conditions" target="_blank" class="link"
            >Vorverkaufsbedingungen</NuxtLink
          >
          gelesen und akzeptiere diese.</label
        >
        <br />
      </div>

      <div v-if="!submitted" class="flex flex-row mt-4 gap-1">
        <button
          :disabled="
            discountCards + regularCards == 0 ||
            performance == null ||
            isSubmitting
          "
          type="submit"
          class="w-full button disabled:opacity-50 disabled:cursor-not-allowed disabled:translate-y-0"
        >
          Hinzufügen für {{ price }}€
        </button>
      </div>
      <div
        v-else
        class="mt-4 text-center bg-green-500/40 p-4 rounded border border-green-600 flex flex-col md:flex-row justify-center items-center gap-2"
      >
        <CheckIcon class="w-8 h-8 text-green-600" aria-hidden="true" />
        <span
          >Wir freuen uns sehr, Sie bei uns begrüßen zu dürfen! Eine
          Bestätigungs-Mail mit allen wichtigen Details ist bereits unterwegs zu
          Ihnen. Bitte beachten Sie, dass der Bestätigungslink nur 30 Minuten
          gültig ist.</span
        >
      </div>
      <p
        v-if="!submitted"
        class="text-xs text-gray-500 max-w-3xl text-center mx-auto"
      >
        Bestätigen Sie Ihre Reservierung bitte direkt per E-Mail. Solange sie
        nicht bestätigt ist, halten wir keine Tickets zurück – andere könnten
        sie sich in der Zwischenzeit sichern.
      </p>
    </form>
  </section>
</template>

<script setup lang="ts">
import { CheckIcon } from "lucide-vue-next";

const {
  handleSubmit,
  isSubmitting,
  price,
  submitted,
  performances,
  name,
  email,
  discountCards,
  regularCards,
  performance,
} = usePresaleForm();
</script>
